import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

function ProfilePageHeader() {
    const pageHeader = useRef(null);
    const [headerData, setHeaderData] = useState({
        title: "SEKILAS YAYASAN",
        image_url: null,
        focus_position: "center",
    });

    // === Ambil data dari API ===
    useEffect(() => {
        const fetchHeader = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/header/about`);
                if (res.data) {
                    setHeaderData({
                        title: res.data.title || "SEKILAS YAYASAN",
                        image_url: res.data.image_url || null,
                        focus_position: res.data.focus_position || "center",
                    });
                }
            } catch (err) {
                console.error("❌ Error fetching header/profile:", err);
            }
        };
        fetchHeader();
    }, []);

    // === Efek parallax & animasi ===
    useEffect(() => {
        AOS.init({ duration: 1000 });
        if (window.innerWidth > 991) {
            const updateScroll = () => {
                if (pageHeader.current) {
                    let windowScrollTop = window.pageYOffset / 3;
                    pageHeader.current.style.transform = `translate3d(0, ${windowScrollTop}px, 0)`;
                }
            };
            window.addEventListener("scroll", updateScroll);
            return () => window.removeEventListener("scroll", updateScroll);
        }
    }, []);

    // === Encode URL biar aman kalau ada spasi ===
    const bgImage = headerData.image_url
        ? encodeURI(`${headerData.image_url}?v=${Date.now()}`)
        : require("assets/img/landing-page.png");

    return (
        <>
            <div className="page-header page-header-small">
                <div
                    className="page-header-image"
                    ref={pageHeader}
                    style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: headerData.focus_position || "center",
                        backgroundRepeat: "no-repeat",
                        minHeight: "60vh",
                    }}
                ></div>

                <div className="content-center">
                    <Container>
                        <h2
                            className="title"
                            data-aos="fade-left"
                            dangerouslySetInnerHTML={{ __html: headerData.title }}
                        ></h2>
                        <div className="underline" data-aos="fade-right" data-aos-delay="300"></div>
                    </Container>
                </div>
            </div>

            <style jsx>{`
                .underline {
                    width: 200px;
                    height: 4px;
                    background-color: white;
                    margin: 10px auto;
                    transition: all 1.5s ease;
                }
            `}</style>
        </>
    );
}

export default ProfilePageHeader;
